var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"bcc-option",class:{
    'selected': _vm.itemSelected,
    'is-disabled': _vm.disabled
  },on:{"click":function($event){$event.stopPropagation();return _vm.selectOptionClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.displayLabel))])]}),_c('bcc-icon',{attrs:{"type":"ic_MenuButton-tick"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }